import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { TextField2 } from 'components/UI';
import styles from './SearchName.module.scss';

interface SearchNameProps {
    searchText: string;
    showSearch: boolean;
    onSearchChange: (query: string) => void;
}

export const SearchName: React.FC<SearchNameProps> = ({ searchText, showSearch, onSearchChange }) => {
    const searchIcon = (
        <FontAwesomeIcon
            icon={faSearch}
            className={clsx(!showSearch ? styles.iconSearch : styles.search)}
        />
    );

    return (
        <div className={styles.inputBox}>
            <TextField2
                id="pet_tags_search_by_personality_name_input"
                placeholder="Search by Tag Name"
                className={styles.input}
                value={searchText}
                onChange={onSearchChange}
                startIcon={searchIcon}
            />
        </div>
    );
};

export default SearchName;
